
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { OperationInfo } from '@/types';

@Component
export default class OperationProvince extends Vue {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;

  get province(): string | null {
    return this.operationInfo?.installationProvince?.toUpperCase() ?? '';
  }
}
